<template>
  <div v-if="me.tn_type != 26 && me.tn_type != 33 && me.tn_type != 37">
    <p class="bold">
      Your XP: {{ MyPoints }}
    </p>
    <p class="bold" v-if="MyRank > 0 && MyRank > 0">
      Your position: {{ MyRank }}
    </p>

    <h6 class="font-weight-bold pb-2"
        v-if="me.tn_type != 26 || me.tn_type != 33 ||  me.tn_type != 37">
      Activities to earn XP:
    </h6>
    <div class="row activities"
         v-if="me.tn_type != 26 || me.tn_type != 33 ||  me.tn_type != 37">
      <div class="col text-center"
           :class="{'alreadyDone':(me.ranking_e >= 5), 'notDone':(me.ranking_e < 5)}">
        <i class="far fa-gamepad-modern fa-2x"></i><br/>
        <div class="badge badge-pill">{{ me.ranking_e}}</div>
      </div>

      <div class="col text-center"
           :class="{'alreadyDone':(me.ranking_a + me.ranking_c >= 300), 'notDone':(me.ranking_a + me.ranking_c < 300)}">
        <i class="far fa-comment-alt fa-2x"></i><br/>
        <div class="badge badge-pill">{{ me.ranking_a + me.ranking_c }}</div>
      </div>

      <div class="col text-center"
           :class="{'alreadyDone':(me.ranking_g >= 200), 'notDone':(me.ranking_g < 200)}">
        <i class="far fa-video fa-2x"></i><br/>
        <div class="badge badge-pill">{{ me.ranking_g }}</div>
      </div>

      <div class="col text-center"
           :class="{'alreadyDone':(me.ranking_d >= 25), 'notDone':(me.ranking_d < 25)}">
        <i class="far fa-user-friends fa-2x"></i><br/>
        <div class="badge badge-pill">{{ me.ranking_d }}</div>
      </div>

      <div class="col text-center"
           :class="{'alreadyDone':(me.ranking_f >= 25), 'notDone':(me.ranking_f < 25)}">
        <i class="far fa-calendar-alt fa-2x"></i><br/>
        <div class="badge badge-pill">{{ me.ranking_f }}</div>
      </div>

      <div class="col text-center"
           :class="{'alreadyDone':(me.ranking_b >= 35), 'notDone':(me.ranking_b < 35)}">
        <i class="far fa-calendar-star fa-2x"></i><br/>
        <div class="badge badge-pill">{{ me.ranking_b }}</div>
      </div>

      <div class="col text-center"
           :class="{'alreadyDone':(me.ranking_m + me.ranking_l + me.ranking_k >= 17), 'notDone':(me.ranking_m + me.ranking_l + me.ranking_k < 17)}">
        <i class="far fa-user-circle fa-2x"></i><br/>
        <div class="badge badge-pill">
          {{ me.ranking_m + me.ranking_l + me.ranking_k }}
        </div>
      </div>

      <div class="col text-center"
           :class="{'alreadyDone':(me.ranking_i + me.ranking_j >= 8), 'notDone':(me.ranking_i + me.ranking_j < 8)}">
        <i class="far fa-door-open fa-2x"></i><br/>
        <div class="badge badge-pill">{{ me.ranking_i + me.ranking_j}}</div>
      </div>

      <div class="col-4"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, onMounted, PropType, ref} from "vue";
import {Me} from "@/store/i/types";
import {useStore} from "vuex";
import {getmyranking} from "@/crud";

const props = defineProps({
  me: {
    type: Object as PropType<Me>,
    required: true,
  }
});

const store = useStore();

const MyPoints = computed(() => {
  return store.getters['i/myPoints'];
});

const MyRank = ref(0);

onMounted(async () => {
  if(props.me?.objvalueid > 0) {
    MyRank.value = await getmyranking(props.me.objvalueid);
  }
});
</script>
